// A table artifact's link cell: its column's link text (or the address's
// host), opening the full address in a new tab. Shared by the table pane's
// grid and the record page's table card, so a link reads the same on both.
import React from "react";
import { Tooltip } from "@mui/material";
import { linkCellText } from "./tableArtifact";

const isWebAddress = (address: string): boolean => {
  try {
    const { protocol } = new URL(address);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};

export const TableLinkCell = ({
  address,
  linkText,
}: {
  address: string;
  linkText?: string;
}) => {
  // The server stores only http(s) addresses; anything else that reaches
  // the page (stale content) is shown as text, never as a link.
  if (!isWebAddress(address)) return <>{address}</>;
  return (
    // The full address on hover: the short text never hides where a link
    // goes. describeChild keeps the link text the link's name.
    <Tooltip title={address} placement="bottom-start" describeChild>
      <a
        href={address}
        target="_blank"
        rel="noopener noreferrer"
        // The grid's truncated cell leaves a click on a link to the link.
        data-table-link
        className="cursor-pointer text-[var(--fp-accent)] underline-offset-2 hover:underline"
      >
        {linkCellText(address, linkText)}
      </a>
    </Tooltip>
  );
};
